import React from 'react';
import Fade from 'react-reveal/Fade';
import NavBrand from '../Navbar/NavBrand';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';

const Footer = () => {
    const workingHours = [
        { id: 1, text: 'Lundi au samedi' },
        { id: 2, text: '8h45 à 20h' }
    ];

    const services = [
        { id: 1, text: 'Conseils sur l’utilisation de produits cosmétiques, diététiques, hygiéniques ou naturels.' },
        { id: 2, text: 'Suivi beauté ou bien-être personnalisé selon le type de peau, l’âge, ou les besoins spécifiques (acné, anti-âge, cheveux…).' }
    ];

    const contact = [
        { id: 1, text: 'Résidence Jinen, Bou Mhel el-Bassatine, Tunisie' },
        { id: 2, text: '+216 57 153 950' },
        { id: 3, text: '+216 99 415 105' }
    ];

    return (
        <Fade left>
            <footer className="text-gray-700 poppins bg-gray-50">
                <div className="max-w-screen-xl px-6 py-16 mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 text-center md:text-left">
                    {/* Logo + Social */}
                    <div className="flex flex-col items-center md:items-start">
                        <NavBrand />
                        <div className="flex gap-4 mt-6">
                            <a
                                href="https://www.facebook.com/paragaia"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:text-blue-800 text-2xl transition"
                            >
                                <FaFacebookF />
                            </a>
                            <a
                                href="https://www.instagram.com/para.gaia/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-pink-600 hover:text-pink-800 text-2xl transition"
                            >
                                <FaInstagram />
                            </a>
                        </div>
                    </div>

                    {/* Working Hours */}
                    <div className="flex flex-col items-center md:items-start">
                        <h2 className="text-paragaia text-lg mb-4 font-semibold tracking-wide">Horaires</h2>
                        <ul className="flex flex-col gap-2">
                            {workingHours.map(item => (
                                <li key={item.id} className="text-sm">{item.text}</li>
                            ))}
                        </ul>
                    </div>

                    {/* Services */}
                    <div className="flex flex-col items-center md:items-start">
                        <h2 className="text-paragaia text-lg mb-4 font-semibold tracking-wide">Services</h2>
                        <ul className="flex flex-col gap-3 max-w-md">
                            {services.map(item => (
                                <li key={item.id} className="text-sm leading-relaxed">{item.text}</li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="flex flex-col items-center md:items-start">
                        <h2 className="text-paragaia text-lg mb-4 font-semibold tracking-wide">Contact</h2>
                        <ul className="flex flex-col gap-2">
                            <li className="text-sm">{contact[0].text}</li>
                            <li>
                                <a href="tel:+21657153950" className="text-sm hover:underline">{contact[1].text}</a>
                            </li>
                            <li>
                                <a href="tel:+21699415105" className="text-sm hover:underline">+216 99 415 105</a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="bg-paragaia mt-10">
                    <div className="max-w-screen-xl mx-auto py-4 px-6 flex flex-col items-center text-center">
                        <p className="text-white text-sm">
                        © 2025 Développé par —
                        <a
                            href="https://github.com/med-aziz-kaboudi"
                            rel="noopener noreferrer"
                            className="text-white ml-1 underline"
                            target="_blank"
                        >
                            Mr. Med Aziz Kaboudi
                        </a>
                        {' '}et{' '}
                        <a
                            href="https://github.com/elfoulena"
                            rel="noopener noreferrer"
                            className="text-white underline"
                            target="_blank"
                        >
                            Mr. Foued Ben Youssef
                        </a>
                        </p>
                    </div>
                </div>
            </footer>
        </Fade>
    );
};

export default Footer;
